import { EEnvironment } from 'core/model/enums/environment.enum';

export const env = (key: string): string => {
  if (import.meta.env[key]) return import.meta.env[key];
  return (window as any)._env_?.[key];
};

export const isTestingEnv = (): boolean => env('NODE_ENV') === EEnvironment.VITEST || !!env('VITEST');
